<template>
  <div :id="getWrapperId">
    <input
      v-if="hasNoFieldRelation"
      type="hidden"
      :name="name"
      :value="storeValue"
    />
    <input
      :id="getId()"
      ref="input"
      :value="numberWithoutCountryCode()"
      class="form-control phone-number"
      type="text"
      dir="ltr"
      :disabled="disabled"
      @keyup.stop="onInput($event)"
      @input="onInput($event)"
      @countrychange="onCountryChange($event)"
      @blur="validateAndVerify"
    />
    <span class="af-icons af-icons-repeat af-icons-animate-rotate fetchingIcon" v-if="fetching"></span>
    <span class="af-icons af-icons-cross mobileExistsIcon" v-if="showMobileExistsAlerts"></span>
    <div class="mobileExistsText" v-if="showMobileExistsAlerts">{{ lang.get('home.register.user_with_mobile_exists') }}</div>
    <span class="af-icons af-icons-tick mobileDoesNotExistIcon" v-if="fullNumber && mobileDoesNotExist"></span>
    <div class="mobileInvalid" v-if="!valid">{{ lang.get('home.register.invalid_mobile') }}</div>
  </div>
</template>

<script>
import intlTelInput from 'intl-tel-input';
import Field from './Field.vue';
import langMixin from './../../components/Translations/mixins/lang-mixin.js';
import phoneValidator from './../../../lib/components/Fields/validator/phone.js';

export default {
  extends: Field,
  mixins: [langMixin],
  props: {
    field: {
      type: Object,
      default: () => ({ id: null, value: null })
    },
    id: {
      type: String,
      default: null
    },
    country: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    verify: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fullNumber: null,
      storeValue: null,
      iti: null,
      validationRules: ['phone'],
      mobileExists: false,
      mobileDoesNotExist: false,
      fetching: false,
      valid: true
    };
  },
  watch: {
    fullNumber(newValue) {
      if (!newValue) {
        this.valid = true;
        this.mobileExists = false;
        this.mobileDoesNotExist = false;
        $('.form-actions input').prop('disabled', false);
      }
    }
  },
  computed: {
    getWrapperId() {
      return this.getId() + '-wrapper';
    },
    hasNoFieldRelation() {
      return !this.field || !this.field.id;
    },
    isRtl() {
      return (document.dir || '') === 'rtl';
    },
    preferedCountry() {
      return [this.country ? this.country : 'US'];
    },
    showMobileExistsAlerts() {
      return this.fullNumber && this.mobileExists;
    }
  },
  created() {
    this.fullNumber = this.value;
  },
  mounted() {
    const input = document.querySelector('#' + this.getId());
    if (input) {
      this.iti = intlTelInput(input, {
        initialCountry: this.country,
        preferredCountries: this.preferedCountry,
        separateDialCode: true,
        utilsScript:
          'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.1.0/js/utils.js' // Public CDN from docs
      });

      setTimeout(() => {
        this.onCountryChange();
      }, 100);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    countryDialCode() {
      return this.iti && this.iti.selectedDialCode
        ? this.iti.selectedDialCode.textContent
        : '';
    },
    getId() {
      if (this.id) {
        return this.id;
      }
      return this.field.slug + '-' + this.elementId;
    },
    onCountryChange() {
      this.$refs.input.style.paddingLeft = this.paddingLeft() + 'px';
      this.onInput({ target: { value: this.$refs.input.value } });
    },
    onInput(event) {
      // We need a slight delay, so when the country selection changes, the plugin knows about this in countryDialCode()
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        let value = (event.target.value + '')
          .trim()
          .replace(/^(0*)/, '')
          .replace('-', ' ');

        // Add country code to the value if it's not present
        if (value && value !== this.countryDialCode() && value[0] !== '+') {
          this.fullNumber = this.countryDialCode() + value;
        } else {
          this.fullNumber = value;
        }

        this.storeValue = this.fullNumber.replace(/\s/g, '');
        this.$emit('input', this.storeValue);
        this.$emit('update:value', this.storeValue);
      }, 200);
    },
    numberWithoutCountryCode() {
      return (this.fullNumber || '').replace(this.countryDialCode(), '');
    },
    paddingLeft() {
      return 58 + this.countryDialCode().length * 8 + (this.isRtl ? 12 : 0);
    },
    validateAndVerify() {
      setTimeout(() => {
        this.validate();

        // Only verify mobile if present and verify prop set to true (registration page)
        if (!!this.fullNumber && this.verify) {
          // Disable register button
          $('.form-actions input').prop('disabled', true);

          this.valid = true;
          this.mobileExists = false;
          this.mobileDoesNotExist = false;

          // Validate mobile
          if (!phoneValidator(this.fullNumber)) {
            this.valid = false;
            return;
          }

          this.fetching = true;

          this.$http.post('/register/verify-mobile', {'mobile': this.fullNumber}).then((response) => {
            this.fetching = false;
            this.toggleAlert(response.data);
          });
        }
      }, 300);
    },
    toggleAlert(mobileExists) {
      if (mobileExists) {
        this.mobileExists = true;
      } else {
        this.mobileDoesNotExist = true;
        if (!$(".emailExistsText").is(':visible')) {
          $('.form-actions input').prop('disabled', false);
        }
      }
    }
  }
};
</script>

<style scoped>
  .iti--separate-dial-code .iti__flag-container {
    left: 0;
    right: auto;
    direction: ltr;
  }

  .fetchingIcon, .mobileExistsIcon, .mobileDoesNotExistIcon {
    float: right;
    margin-right: 10px;
    margin-top: -27px;
    position: relative;
    z-index: 2;
    cursor: default;
  }

  .mobileInvalid {
    color: red;
    margin-top: 5px;
  }

  .mobileExistsIcon {
    color: red;
  }

  .mobileExistsText {
    color: red;
    margin-top: 5px;
  }

  .mobileDoesNotExistIcon {
    color: green;
  }
</style>
